/* ============================================================
   topurbano
   ============================================================ */

export const topurbano = {
    id: "3",
    type: "playlist",
    featured: true,
    title: "Top Urbano",
    link: "top-urbano",
    playlistBg: "rgb(238, 109, 252)",
    imgUrl: "/image/listas/urbano/01.jpg", // /image/listas/urbano/urbano.jpg
    hoverColor: "rgb(238, 109, 252)",
    artist: "mixtape",
    artistImgUrl: "../image/djs/mixtape/mixtape.png",
    artistBio: "Collection",
    artistDownload: "Descargar",
    bannerUno: "",
    downloadData: [],
    playlistData: [
      {
        id: "1",
        songName: "offline",
        songimg: "/image/listas/urbano/01.jpg",
        songArtist: "Young Miko",
        artistLink: "young-miko",
        link: "https://dl.dropbox.com/scl/fi/rmrwr977oo7dcsv553ly0/Young-Miko-offline.mp3?rlkey=mznqe8tzr4vxd6i76f4krp2up&dl=1",
        trackTime: "3:22"
      },
      {
        id: "2",
        songName: "LA FALDA",
        songimg: "/image/listas/urbano/02.jpg",
        songArtist: "Myke Towers",
        artistLink: "myke-towers",
        link: "https://dl.dropbox.com/scl/fi/wc5430y2jsxz7sxdetj82/Myke-Towers-LA-FALDA.mp3?rlkey=zrjojgcaq2srf25irz6ppb18g&dl=1",
        trackTime: "2:54"
      },
      {
        id: "3",
        songName: "Santa",
        songimg: "../image/listas/urbano/03.jpg",
        songArtist: "Rvssian",
        artistLink: "rvssian",
        link: "https://dl.dropbox.com/scl/fi/ucayn3l92j9dnun4s5r5f/Rvssian-Santa.mp3?rlkey=tdsk5vstugzukizfwjuk7768z&dl=1",
        trackTime: "3:13"
      },
      {
        id: "4",
        songName: "LUNA",
        songimg: "../image/listas/urbano/04.jpg",
        songArtist: "Feid",
        artistLink: "feid",
        link: "https://dl.dropbox.com/scl/fi/di7c1axcm62l7itx6ac4u/Feid-LUNA.mp3?rlkey=oj0wwb0jqh4h7taeyrlxzlf6l&dl=1",
        trackTime: "3:17"
      },
      {
        id: "5",
        songName: "MODELITO",
        songimg: "../image/listas/urbano/05.jpg",
        songArtist: "Mora",
        artistLink: "mora",
        link: "https://dl.dropbox.com/scl/fi/wcbs9rvmc0gpoz6v441e1/Mora-MODELITO.mp3?rlkey=i7novdxoyqzrct3y85jevrdzf&dl=1",
        trackTime: "3:11"
      },
      {
        id: "6",
        songName: "CONTIGO",
        songimg: "../image/listas/urbano/06.jpg",
        songArtist: "Karol G",
        artistLink: "karol-g",
        link: "https://dl.dropbox.com/scl/fi/s5rfue5ahl6nvjklqw7gj/KAROL-G-CONTIGO.mp3?rlkey=jy27go1nk2dgjvsa5o75gdzuu&dl=1",
        trackTime: "3:13"
      },
      {
        id: "7",
        songName: "1000COSAS",
        songimg: "../image/listas/urbano/07.jpg",
        songArtist: "Lola Indigo",
        artistLink: "lola-indigo",
        link: "https://dl.dropbox.com/scl/fi/qvrf3s5w5qum3t5rf43oe/Lola-Indigo-1000COSAS.mp3?rlkey=xd7is7vjkq2ex03vrkr2t29p6&dl=1",
        trackTime: "4:00"
      },
      {
        id: "8",
        songName: "CRUSH",
        songimg: "../image/listas/urbano/08.jpg",
        songArtist: "Sky",
        artistLink: "sky",
        link: "https://dl.dropbox.com/scl/fi/vrh4tztmaeoiq42amdhmc/Sky-CRUSH.mp3?rlkey=rfi819x3wpmnfvyye25ls0kh6&dl=1",
        trackTime: "3:53",

        genre: "urban pop",
        genres: ["urban", "pop", "hip-hop"],
      },
      {
        id: "9",
        songName: "Nassau",
        songimg: "../image/listas/urbano/09.jpg",
        songArtist: "Shakira",
        artistLink: "shakira",
        link: "https://dl.dropbox.com/scl/fi/2v1po0vsq0c3bgz62hqn7/Shakira-Nassau.mp3?rlkey=rwtj0dumsrhyhu2oz1r8uypy3&dl=1",
        trackTime: "2:37",

        genre: "latin pop",
        genres: ["latin", "pop", "urban"],
      },
      {
        id: "10",
        songName: "COSMETICOS",
        songimg: "../image/listas/urbano/10.jpg",
        songArtist: "Myke Towers",
        artistLink: "myke-towers",
        link: "https://dl.dropbox.com/scl/fi/t23ic6hbwow23wi8dglra/Myke-Towers-COSMETICOS.mp3?rlkey=vz8pcnbdy47xe77o5d9xblmfx&dl=1",
        trackTime: "2:22"
      }
    ]
  }
